import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { MuiOtpInput } from 'mui-one-time-password-input'
import { useState } from 'react';
import { HttpStatusCode } from 'axios';
import Alert from '@mui/material/Alert';
import { axiosHttp } from '../../AxiosWrapper';
import CountDownView from './CountDownView';

const OtpVerificationView = ({ ref, token, verifyCallback, userData }) => {
    const [otp, setOtp] = useState('');
    const [showCountDown, setShowCountDown] = useState(false);
    const [verifyInProgress, setVerifyInProgress] = useState(false);
    const [resendOtpInProgress, setResendOtpInProgress] = useState(false);
    const [resendOtpError, setResendOtpError] = useState(false);

    const handleChange = (newValue) => {
        setOtp(newValue)
    }

    const verifyOTP = () => {
        if(!otp || otp.trim() === ""){
            return;
        }
        setVerifyInProgress(true);
        axiosHttp.post("/api/pub/dss/v1/verifyOtp", { token: token, otp: otp, ref: ref })
            .then((res) => {
                verifyCallback(res.data);
            })
            .catch((error) => { })
            .then((res) => {
                setVerifyInProgress(false);
            })
    }

    const sendOTP = () => {
        setOtp('');
        setResendOtpError(false);
        setResendOtpInProgress(true);
        let postData = { token: token, ref: ref };
        if(userData){
            Object.keys(userData).map((key)=>{
                postData[key] = userData[key];
            })
        }
        axiosHttp.post("/api/pub/dss/v1/sendOtp", postData)
            .then((res) => {
                if (res?.data.status === HttpStatusCode.Ok && res.data.content.sentOtp === true) {
                    setShowCountDown(true);
                } else {
                    setResendOtpError(true);
                }
            })
            .catch((error) => {
                setResendOtpError(true);
             })
            .then((res) => {
                setResendOtpInProgress(false);
            })
    }
    return (
        <Stack sx={{ p: 1, mt: .5 }}>
            <MuiOtpInput
                sx={{ px: { xs: 0, md: 5 } }}
                length={5}
                value={otp}
                onChange={handleChange}
                TextFieldsProps={{
                    //type: 'number', // Ensure numeric keyboard on mobile
                    inputProps: {
                        // inputMode: 'numeric',
                        pattern: '[0-9]*', // Restrict input to digits
                    },
                }}
            />
            <Box sx={{ display: "flex", justifyContent: "end" }}>
                <Button disabled={showCountDown} loading={resendOtpInProgress} onClick={sendOTP} sx={{ textTransform: "none", mr: { xs: 0, md: 4 }, mt: .5 }}>
                    {showCountDown && <CountDownView startFrom={30} onCountdownEnd={() => setShowCountDown(false)} />} Resend OTP
                </Button>
            </Box>
            {resendOtpError &&<Alert sx={{borderRadius:3 }}  severity='warning'>Resend otp failed!. Please try again later</Alert>}
            <Box sx={{ display: "flex", alignItems:"center", justifyContent:"center"}}>
                <Button loading={verifyInProgress} onClick={verifyOTP} variant='contained' sx={{ mt: 2, px: 10, py: {xs:.5, m:1.5}, borderRadius: 6 }}>Verify</Button>
            </Box>
        </Stack>
    );

};

export default OtpVerificationView;